import React from 'react';
import TagGroupEditNavbar from '../TagGroupEditNavbar';
import TagGroupEditInfo from '../TagGroupEditInfo';
import TagGroupEditItems from '../TagGroupEditItems';
import './TagGroupEditWrap.scss';

const TagEditWrap = (props) => {
  const {
    form,
    tagGroupEdit,
    onSubmit,
    setData,
    onChangeTagGroupName,
    getTagGroupItemList,
    selectTagGroupItemList,
    getRelatedTagList,
    getTagGroupAllListExcelDownload,
    getTagGroupSelectedListExcelDownload,
    setTagGroupExcelUpload,
  } = props;
  const { tagGroupInfo, tagGroupItem, editableTagGroup } = tagGroupEdit;

  return (
    <div className="tag-group-edit-wrap">
      {/* 하단 네브바 */}
      <TagGroupEditNavbar editableTagGroup={editableTagGroup} onSubmit={onSubmit} />

      {/* 태그 그룹 정보 */}
      <TagGroupEditInfo
        form={form}
        tagGroupInfo={tagGroupInfo}
        setData={(data) =>
          setData({
            path: ['tagGroupEdit', 'tagGroupInfo', ...data.path],
            value: data.value,
          })
        }
        onChangeTagGroupName={onChangeTagGroupName}
      />

      {/* 태그 그룹에 연결된 아이템 */}
      <TagGroupEditItems
        tagGroupItem={tagGroupItem}
        getTagGroupItemList={getTagGroupItemList}
        selectTagGroupItemList={selectTagGroupItemList}
        getRelatedTagList={getRelatedTagList}
        getTagGroupAllListExcelDownload={getTagGroupAllListExcelDownload}
        getTagGroupSelectedListExcelDownload={getTagGroupSelectedListExcelDownload}
        setTagGroupExcelUpload={setTagGroupExcelUpload}
      />
    </div>
  );
};

export default TagEditWrap;
